import { OnboardingBrandSetup } from "./steps/brand"
import { OnboardingCompanySetup } from "./steps/company"
import { OnboardingCompletedSetup } from "./steps/completed"
import { OnboardingIndustrySetup } from "./steps/industry"
import { OnboardingUserSetup } from "./steps/user"
import { TStepMap } from "./types"
import { TFunction } from "i18next"
import { OnboardingFoundMatchSetup } from "./steps/foundMatch"
import { Trans } from "react-i18next"
import { TEnrichPerson } from "@cakemail-org/ui-components-v2"
import { ManageAccountsConfirmationSetup } from "./steps/manageAccountsConfirmation"
export function getStepMap(stringParams: any, t: TFunction, enrichedPerson?: TEnrichPerson | null): TStepMap {

    return {
        foundMatch: {
            id: 1,
            title: t("onboarding-found-match-title", stringParams) as string,
            desc: t("onboarding-found-match-desc", stringParams) as string,
            name: "foundMatch",
            component: <OnboardingFoundMatchSetup />
        },
        user: {
            id: 2,
            title: t("onboarding-user-title", stringParams) as string,
            desc: t("onboarding-user-desc", stringParams) as string,
            enrichTitle: t(enrichedPerson?.organization ? "onboarding-user-enrich-title" : "onboarding-user-enrich-title-no-org", stringParams) as string,
            enrichDesc: t("onboarding-user-enrich-desc", stringParams) as string,
            name: "user",
            component: <OnboardingUserSetup />
        },
        industry: {
            id: 3,
            title: t("onboarding-industry-title", stringParams) as string,
            desc: t("onboarding-industry-desc", stringParams) as string,
            enrichTitle: t("onboarding-industry-enrich-title", stringParams) as string,
            name: "industry",
            component: <OnboardingIndustrySetup />
        },
        manageAccountsConfirmation: {
            id: 4,
            title: t("onboarding-manage-users-confirmation-title", stringParams) as string,
            desc: t("onboarding-manage-users-confirmation-desc", stringParams) as string,
            name: "manageAccountsConfirmation",
            component: <ManageAccountsConfirmationSetup />
        },
        company: {
            id: 5,
            title: t("onboarding-company-title", stringParams) as string,
            desc: <Trans i18nKey="onboarding-company-desc" values={stringParams} />,
            enrichTitle: t("onboarding-company-enrich-title", stringParams) as string,
            name: "company",
            component: <OnboardingCompanySetup />
        },
        brand: {
            id: 6,
            title: t("onboarding-brand-title", stringParams) as string,
            desc: t("onboarding-brand-desc", stringParams) as string,
            enrichTitle: t("onboarding-brand-enrich-title", stringParams) as string,
            name: "brand",
            component: <OnboardingBrandSetup />
        },
        completed: {
            id: 7,
            title: t("onboarding-completed-title", stringParams) as string,
            desc: t("onboarding-completed-desc", stringParams) as string,
            name: "completed",
            component: <OnboardingCompletedSetup />
        }
    }
}